export default __webpack_public_path__ + "static/media/testimoniall.8446ff26.jpg";